<template>
	<component :is="currComponent" :index="String(menu.menuId)">
		<router-link class="anchor" :to="toRoute" v-if="!hasChild && currIcon">
			<el-icon><component :is="currIcon" /></el-icon>
		</router-link>
		<template #title v-if="hasChild">
			<el-icon><component :is="currIcon" /></el-icon>
			<span>{{ menu.meta.title }}</span>
		</template>
		<template #title v-else>
			<span v-if="menu.parentMenuId === 0">{{ menu.meta.title }}</span>
			<router-link class="anchor" v-else :to="toRoute">{{ menu.meta.title }}</router-link>
		</template>

		<LayoutMenuItem v-for="childMenu in menu.children" :key="childMenu.meta.menuId" :menu="childMenu" />
	</component>
</template>

<script lang="ts" setup>
import { ElSubMenu, ElMenuItem } from 'element-plus'
import { Memo, Setting, Document, UserFilled, User, Files, Odometer, ChatDotSquare, Bicycle, TrendCharts, TurnOff, Collection, VideoCamera } from '@element-plus/icons-vue'
import type { Menu } from '@/api/permission'

const icon2componentMap = new Map([
	['memo', Memo],
	['setting', Setting],
	['document', Document],
	['teacher', UserFilled],
	['learner', User],
	['database', Files],
	['pointsConfig', Odometer],
	['visitorConfig', Bicycle],
	['pcOperate', ChatDotSquare],
	['stat', TrendCharts],
	['abilityDimension', TurnOff],
	['trainFrameEvaluate', Collection],
	['video-camera', VideoCamera],
])
const props = defineProps<{ menu: Menu }>()
const hasChild = computed(() => {
	return !!props.menu?.children?.length
})
const currComponent = computed(() => {
	return hasChild.value ? ElSubMenu : ElMenuItem
})

const currIcon = computed(() => {
	return icon2componentMap.get(props.menu.meta.icon as string)
})

const toRoute = computed(() => {
	return { path: props.menu.path }
})
</script>

<style lang="scss" scoped></style>
